import { SliderSettings } from "../../../../Shared/components/CardLayout/SliderSettings";
import { useOrderFlow } from "../../../OrderFlowProvider/OrderFlowContext";
import { ModuleNames } from "../../../OrderFlowProvider/OrderFlowTypes";
import { handleDispatchDecrementMealBundleQuantity, handleDispatchIncrementMealBundleQuantity, handleDispatchToggleMealBundle, } from "./mealBundleChooserUtils";
import { useCompanyConfigQuery } from "../../../../SWR/Company/useCompanyConfigQuery";
import { getMealDatesForBundle } from "../../../hooks/useHelpers";
export const useMealBundleChooser = (sequenceNumber) => {
    var _a;
    const { store, dispatch } = useOrderFlow();
    const { startSunday } = useCompanyConfigQuery();
    const moduleConfig = (_a = store.model.Flow.FlowModules.find((m) => m.ModuleName === ModuleNames.MEAL_BUNDLE_CHOOSER &&
        m.Sequence === sequenceNumber &&
        m.Page === store.cart.currentPage)) === null || _a === void 0 ? void 0 : _a.ModuleConfig;
    const { BundleBuilder, GridSpacing, IsGridLayout, MealBundleDisplayMode, ImageDisplayMode, ImageHeight, MealBundleSelectionMode, ScreenLG, ScreenMD, ScreenSM, ScreenXS, CenterCards, CardDescriptionLines, ShowDescription, ButtonTooltipDesktop, ButtonTooltipMobile, CardToolTipMobile, } = moduleConfig;
    // Filter programMeals based on meal size or use all programMeals.
    const programMealsToRender = store.cart.mealSize
        ? store.model.Program.ProgramMeals.filter((programMeal) => {
            var _a, _b;
            return programMeal.MealSize === ((_a = store.cart.mealSize) === null || _a === void 0 ? void 0 : _a.Size) ||
                ((_b = store.cart.mealSize) === null || _b === void 0 ? void 0 : _b.Size) === store.model.allMealSizeOption;
        })
        : store.model.Program.ProgramMeals;
    const filteredBundles = BundleBuilder.map((bundle) => {
        const filteredBundleMeals = bundle.BundleMeals.filter((bm) => programMealsToRender.find((pm) => pm.ProgramMealId === bm.ProgramMealId));
        return Object.assign(Object.assign({}, bundle), { BundleMeals: filteredBundleMeals });
    });
    const toolTipSettings = {
        buttonToolTipDesktop: ButtonTooltipDesktop,
        buttonToolTipMobile: ButtonTooltipMobile,
        cardToolTipMobile: CardToolTipMobile,
    };
    const mealBundleCardLayoutSettings = {
        isGridLayout: IsGridLayout,
        sliderSettings: SliderSettings(ScreenLG, ScreenMD, ScreenSM, ScreenXS),
        cardsPerRowXS: ScreenXS,
        cardsPerRowSM: ScreenSM,
        cardsPerRowMD: ScreenMD,
        cardsPerRowLG: ScreenLG,
        gridSpacing: GridSpacing,
        CenterCards,
    };
    return {
        BundleBuilder: filteredBundles,
        MealBundleDisplayMode,
        ImageDisplayMode,
        ImageHeight,
        CardDescriptionLines,
        showDescription: ShowDescription,
        MealBundleSelectionMode,
        mealBundleCardLayoutSettings,
        selectedMealBundles: store.cart.bundles.filter((bundle) => bundle.Quantity > 0),
        MealBundleImageBaseUrl: store.model.MealBundleImageBaseUrl,
        handleDispatchToggleMealBundle: handleDispatchToggleMealBundle(dispatch, store.model.Program.ProgramMeals, store.cart.template, store.cart.bundles),
        handleDispatchIncrementMealBundleQuantity: handleDispatchIncrementMealBundleQuantity(dispatch, getMealDatesForBundle(store.cart.daysOfWeek, store.model.DeliveryDays, store.cart.startDate, startSunday, store.cart.subscriptionPeriod, store.cart.oneTimeOrderPeriod, store.cart.isSubscription), store.model.Program.ProgramMeals, store.cart.template, store.cart.daysOfWeek.length, store.cart.bundles),
        handleDispatchDecrementMealBundleQuantity: handleDispatchDecrementMealBundleQuantity(dispatch, store.model.Program.ProgramMeals, store.cart.template, store.cart.bundles),
        toolTipSettings,
    };
};
